<template>
  <article class="video-check">
    <section class="live">
      <VideoWithButton @video-confirmed="confirmedHandler" />
    </section>
    <section class="recorded">
      <video ref="v2" controls />
      <h3>Chunks</h3>
      <ol>
        <li v-for="(vid, idx) in chunkedVideos" :key="vid.snippetId">
          <button @click="() => play(idx)">{{ idx + 1 }}</button>
        </li>
      </ol>
      <button v-if="eop" @click="playEoP">EoP</button>
    </section>
  </article>
</template>

<script>
// NOTE: This is a PoC for reference purposes only.
// Burn after reading.
import { mapState } from 'vuex'
import VideoWithButton from '@/components/VideoWithButton/VideoWithButton.vue'
import VideoRecorder from '@/util/VideoRecorder'
/* eslint-disable no-unused-vars */
export default {
  name: 'Video',
  components: { VideoWithButton },
  data() {
    return {
      r1: undefined,
      r2: undefined,
      chunkedVideos: [],
      eop: undefined
    }
  },
  computed: {
    ...mapState('video', ['stream'])
  },
  watch: {
    stream: {
      immediate: true,
      handler(n, o) {
        if (this.stream) {
          this.r1 = new VideoRecorder(this.stream, this.getVideoSnippets)
          this.r2 = new VideoRecorder(this.stream, this.setEop)
          this.makeSnippets(this.r1)
          this.EoP()
        }
      }
    }
  },
  methods: {
    confirmedHandler() {
      this.$router.push({ name: 'Home' })
    },
    makeSnippets(recorder, lengthMS = 5000, restMS = 1000, howMany = 3) {
      let counter = 0
      const t = setInterval(() => {
        ++counter
        if (recorder?.isRecording) {
          recorder.stop()
        }
        if (counter > howMany) {
          clearInterval(t)
        } else {
          recorder.record(`test-${counter}`)
        }
      }, lengthMS)
    },
    getVideoSnippets(videos) {
      this.chunkedVideos = videos
    },
    setEop(videos) {
      this.eop = videos?.[0]
    },
    EoP() {
      this.r2.record('eop')
      setTimeout(() => this.r2.stop(), 15000)
    },
    play(idx) {
      const { v2 } = this.$refs
      v2.src = this.chunkedVideos[idx]?.url
      v2.play()
    },
    playEoP(idx) {
      const { v2 } = this.$refs
      v2.src = this.eop?.url
      v2.play()
    }
  }
}
</script>
<style lang="scss">
.video-check {
  width: 80%;
  min-width: 30rem;
  margin: 1.5rem auto;
  video {
    width: 640px;
    height: 480px;
    background-color: #fafafa;
  }
}
</style>
